import * as React from "react";
import Box from "@mui/material/Box";
import Link from "@mui/material/Link";
import theme from "../../Styles/theme";
import { ArrowLeft } from "react-feather";
import { useNavigate } from "react-router-dom";
import { app_base_url } from "../../Utils/Urls";
import { useEntidade } from "../../Hooks/EntidadeHook";

export function Menu() {
  const location = window.location.href;
  const { entidade } = useEntidade();
  const navigate = useNavigate();

  const linkStyles = (active: boolean) => ({
    border: `2px solid ${active ? theme.colors.primary : theme.colors.primary}`,
    padding: "6px 12px",
    borderRadius: "8px",
    color: active ? theme.colors.primary : theme.colors.primary,
    cursor: "pointer",
    fontWeight: active ? "bold" : "normal",
    textAlign: "center",
    transition: "0.3s",
    "&:hover": {
      backgroundColor: theme.colors.primary,
      color: "white",
    },
    display: "flex",
    alignItems: "center",
    gap: "8px",
  });

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        gap: "16px",
        padding: "12px",
        flexWrap: "wrap",
        alignItems: "center",
      }}
    >
      <Link onClick={() => navigate(-1)} underline="none" sx={linkStyles(location.includes("voltar"))}>
        <ArrowLeft /> VOLTAR
      </Link>

      <Link
        onClick={() => navigate(`${app_base_url}/${entidade.banco}/geral`)}
        underline="none"
        sx={linkStyles(location.includes("geral"))}
      >
        VISUALIZAR TODAS AS GUIAS
      </Link>

      <Link
        onClick={() => navigate(`${app_base_url}/${entidade.banco}/empresas`)}
        underline="none"
        sx={linkStyles(location.includes("empresas"))}
      >
        SELECIONAR EMPRESA
      </Link>
    </Box>
  );
}